const removeNonDigits = (number) => (number ? number.replace(/\D/g, '') : '')

export default removeNonDigits
